module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border heading-cart clearfix"
  }, [_c('div', {
    staticClass: "clearfix pull-left col-md-12"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_c('h3', {
    staticClass: "box-title",
    staticStyle: {
      "font-size": "20px",
      "margin-left": "-17px"
    }
  }, [_vm._v("Adspots Layouts Association")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right clearfix import",
    staticStyle: {
      "padding": "5px",
      "padding-top": "0px",
      "padding-right": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-9 text-right"
  }, [_c('el-dropdown', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.importedData),
      expression: "!importedData"
    }],
    attrs: {
      "trigger": "click"
    },
    on: {
      "command": _vm.selectedBucket
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("\n                                        Import Config\n                                        "), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, _vm._l((_vm.importBuckets), function(bucket, index) {
    return _c('el-dropdown-item', {
      key: 'bucketindex' + index,
      attrs: {
        "command": index
      }
    }, [_vm._v(_vm._s(bucket.bucketName))])
  }), 1)], 1), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.importedData),
      expression: "importedData"
    }],
    staticClass: "el-button el-button--danger",
    on: {
      "click": function($event) {
        return _vm.removeImport()
      }
    }
  }, [_vm._v("\n                                    Remove\n                                ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 no-padding"
  }, [_c('button', {
    staticClass: "el-button el-button--success",
    attrs: {
      "disabled": !_vm.importedData
    },
    on: {
      "click": function($event) {
        return _vm.saveImportedData()
      }
    }
  }, [_vm._v("\n                                    Save\n                                ")])])])]), _vm._v(" "), (_vm.formLoadingDone) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "m-l-20 form-label",
    staticStyle: {
      "margin-left": "5px"
    }
  }, [_vm._v("Ad Spots:")]), _vm._v(" "), _c('el-select', {
    key: _vm.randomNumber,
    staticClass: "col",
    staticStyle: {
      "display": "inline-block",
      "max-width": "215px"
    },
    attrs: {
      "placeholder": "Search and select ad spot",
      "loading": _vm.dropdownLoading.adSpot,
      "multiple": "",
      "clearable": "",
      "filterable": ""
    },
    model: {
      value: (_vm.filterData.adSpotId),
      callback: function($$v) {
        _vm.$set(_vm.filterData, "adSpotId", $$v)
      },
      expression: "filterData.adSpotId"
    }
  }, _vm._l((_vm.allIndividualAdspots), function(adspot, index) {
    return _c('el-option', {
      key: 'alias name' + index,
      attrs: {
        "label": adspot.alias_name,
        "value": adspot.id
      }
    }, [_vm._v("\n                                    " + _vm._s(adspot.alias_name) + "\n                                ")])
  }), 1), _vm._v(" "), _c('span', {
    staticClass: "m-l-20 form-label",
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("Unique Id:")]), _vm._v(" "), _c('el-select', {
    staticClass: "col",
    staticStyle: {
      "display": "inline-block",
      "max-width": "215px"
    },
    attrs: {
      "loading": _vm.dropdownLoading.adSpot,
      "value": _vm.fakeAdSpotId,
      "placeholder": "Search and select unique id",
      "multiple": "",
      "clearable": "",
      "filterable": ""
    },
    on: {
      "input": _vm.setUniqueOrAdFormat
    }
  }, _vm._l((_vm.getUniqueOrAdFormat()), function(adspot, index) {
    return _c('el-option', {
      key: 'unique id keys' + index,
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "label": adspot.is_existing ? adspot.unique_id : _vm.getAdTypeName(adspot.fi_ad_type),
        "value": adspot.id
      }
    }, [_vm._v("\n                                    " + _vm._s(adspot.is_existing ? adspot.unique_id : _vm.getAdTypeName(adspot.fi_ad_type)) + "\n                                ")])
  }), 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('span', {
    staticClass: "m-l-20 form-label",
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("Layout:")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "display": "inline-block",
      "width": "215px"
    },
    attrs: {
      "loading": _vm.dropdownLoading.adLayout,
      "placeholder": "Search and select layout",
      "multiple": "",
      "clearable": "",
      "filterable": ""
    },
    model: {
      value: (_vm.filterData.adLayout),
      callback: function($$v) {
        _vm.$set(_vm.filterData, "adLayout", $$v)
      },
      expression: "filterData.adLayout"
    }
  }, _vm._l((_vm.allIndividualLayouts), function(layout, index) {
    return _c('el-option', {
      key: 'layout keys' + index,
      attrs: {
        "label": layout.layout_name,
        "value": layout.id
      }
    }, [_vm._v("\n                                    " + _vm._s(layout.layout_name) + "\n                                ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "padding-top": "10px",
      "padding-right": "7px",
      "margin-left": "5px"
    }
  }, [_c('div', {
    staticStyle: {
      "flex": "auto"
    }
  }, [_c('span', {
    staticClass: "m-l-20 form-label",
    staticStyle: {
      "margin-left": "-16px"
    }
  }, [_vm._v("Tag Name:")]), _vm._v(" "), _c('el-select', {
    staticClass: "col",
    staticStyle: {
      "display": "inline-block",
      "max-width": "208px",
      "margin-top": "10px"
    },
    attrs: {
      "loading": _vm.dropdownLoading.adHbAdUnit,
      "placeholder": "Search and select tag name",
      "multiple": "",
      "clearable": "",
      "filterable": ""
    },
    model: {
      value: (_vm.filterData.adHbAdUnit),
      callback: function($$v) {
        _vm.$set(_vm.filterData, "adHbAdUnit", $$v)
      },
      expression: "filterData.adHbAdUnit"
    }
  }, _vm._l((_vm.allIndividualHBAdUnits), function(hb_id, index) {
    return _c('el-option', {
      key: 'tagnamekeys' + index,
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "label": hb_id.name,
        "value": hb_id.id
      }
    }, [_vm._v("\n                                        " + _vm._s(hb_id.name) + "\n                                    ")])
  }), 1), _vm._v(" "), _c('span', {
    staticClass: "m-l-20 form-label",
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("Dimension:")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "display": "inline-block",
      "max-width": "300px"
    },
    attrs: {
      "placeholder": "Select dimensions",
      "multiple": "",
      "clearable": "",
      "filterable": "",
      "loading": _vm.loading
    },
    model: {
      value: (_vm.filterData.adDimensions),
      callback: function($$v) {
        _vm.$set(_vm.filterData, "adDimensions", $$v)
      },
      expression: "filterData.adDimensions"
    }
  }, _vm._l((_vm.dimensions), function(dimension, index) {
    return _c('el-option', {
      key: 'abc' + index,
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "label": ((dimension.width) + "x" + (dimension.height)),
        "value": dimension.id
      }
    })
  }), 1), _vm._v(" "), _c('span', {
    staticClass: "m-l-20 form-label",
    staticStyle: {
      "margin-left": "43px"
    }
  }, [_vm._v("Status:")]), _vm._v(" "), _c('el-radio-group', {
    staticStyle: {
      "display": "inline-block",
      "max-width": "300px",
      "height": "40px"
    },
    attrs: {
      "size": "medium"
    },
    model: {
      value: (_vm.filterData.adIsLive),
      callback: function($$v) {
        _vm.$set(_vm.filterData, "adIsLive", $$v)
      },
      expression: "filterData.adIsLive"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": null
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": true
    }
  }, [_vm._v("Live")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": false
    }
  }, [_vm._v("Demo")])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "pull-right m-t-10",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "size": "medium",
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.clearFilter()
      }
    }
  }, [_vm._v("\n                                    Clear Filters\n                                ")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.importedData) ? _c('span', {
    staticClass: "text-danger animated flash config-notif"
  }, [_vm._v("\n                        Imported config from\n                        " + _vm._s(_vm.selectedBucketData.bucketName) + " Bucket. Click save to use the config.\n                    ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading || _vm.associatedAdSpots === undefined),
      expression: "loading || associatedAdSpots===undefined"
    }],
    staticStyle: {
      "width": "100%",
      "border-spacing": "0"
    },
    attrs: {
      "height": "400",
      "data": _vm.associatedAdSpots,
      "id": "assoc-table"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Alias Name",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v("\n                            " + _vm._s(props.row.layout.ad_spot.alias_name) + "\n                            "), (!props.row.layout.ad_spot.is_existing) ? _c('span', [_vm._v("\n                                (" + _vm._s(_vm.getAdTypeName(props.row.layout.ad_spot.fi_ad_type)) + "\n                                ad format)\n                            ")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
          attrs: {
            "to": {
              path: ("/admin/publisher/" + _vm.uuid + "/domain/" + _vm.domId + "/ad-spot-setup/"),
              query: {
                spot_id: props.row.layout.ad_spot.id,
              },
            }
          }
        }, [_vm._v("\n                                View ad spot\n                            ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Unique Id / Ad Format"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('span', [_vm._v(_vm._s(_vm.getAdTypeName(props.row.layout.ad_spot.fi_ad_type) != '-' ?
          _vm.getAdTypeName(props.row.layout.ad_spot.fi_ad_type) :
          props.row.layout.ad_spot.unique_id))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Layout",
      "prop": "layout.layout.layout_name",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "HB?",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [(props.row.is_hb) ? _c('div', {
          staticClass: "text-center"
        }, [_c('svg', {
          staticClass: "svg-inline--fa fa-check-circle fa-w-16 fa-2x",
          attrs: {
            "data-v-7a40f996": "",
            "aria-hidden": "true",
            "height": "20px",
            "width": "20px",
            "data-prefix": "far",
            "data-icon": "check-circle",
            "role": "img",
            "xmlns": "http://www.w3.org/2000/svg",
            "viewBox": "0 0 512 512"
          }
        }, [_c('path', {
          attrs: {
            "data-v-7a40f996": "",
            "fill": "green",
            "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
          }
        })])]) : _vm._e(), _vm._v(" "), (!props.row.is_hb) ? _c('div', {
          staticClass: "text-center"
        }, [_c('svg', {
          staticClass: "svg-inline--fa fa-times-circle fa-w-16 fa-2x",
          attrs: {
            "aria-hidden": "true",
            "height": "20px",
            "width": "20px",
            "data-prefix": "fal",
            "data-icon": "times-circle",
            "role": "img",
            "xmlns": "http://www.w3.org/2000/svg",
            "viewBox": "0 0 512 512"
          }
        }, [_c('path', {
          attrs: {
            "fill": "red",
            "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 464c-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216zm94.8-285.3L281.5 256l69.3 69.3c4.7 4.7 4.7 12.3 0 17l-8.5 8.5c-4.7 4.7-12.3 4.7-17 0L256 281.5l-69.3 69.3c-4.7 4.7-12.3 4.7-17 0l-8.5-8.5c-4.7-4.7-4.7-12.3 0-17l69.3-69.3-69.3-69.3c-4.7-4.7-4.7-12.3 0-17l8.5-8.5c4.7-4.7 12.3-4.7 17 0l69.3 69.3 69.3-69.3c4.7-4.7 12.3-4.7 17 0l8.5 8.5c4.6 4.7 4.6 12.3 0 17z"
          }
        })])]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Tag Name(s)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v("\n                            " + _vm._s(props.row.is_hb ?
          props.row.hb_ids.map(function (hb_id) { return _vm.getAdunitPath(hb_id); }).join('\n') :
          props.row.dfp_id.dfp_network.network_code +
          '/' +
          props.row.dfp_id.ad_unit_name) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Edit",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('button', {
          staticClass: "el-button btn-rounded el-button--success edit",
          on: {
            "click": function($event) {
              return _vm.editAdSpotTagAssoc(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "ti-pencil"
        })])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Delete",
      "width": "70"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('button', {
          staticClass: "el-button btn-rounded el-button--danger edit",
          on: {
            "click": function($event) {
              return _vm.deleteAdSpotTagAssoc(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "ti-close"
        })])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Dimension/s",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('div', {
          staticClass: "col-md-10"
        }, _vm._l((props.row.dimensions), function(dimension) {
          return _c('p', {
            key: 'agedlsf' + dimension.id,
            staticStyle: {
              "margin": "0px",
              "font-size": "13px"
            }
          }, [_vm._v("\n                                    " + _vm._s(dimension.width) + " X\n                                    " + _vm._s(dimension.height) + "\n                                ")])
        }), 0)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Status",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('div', {
          staticClass: "col-md-10"
        }, [(props.row.is_live) ? _c('el-tooltip', {
          attrs: {
            "content": "live",
            "placement": "top"
          }
        }, [_c('i', {
          staticClass: "el-icon-success",
          staticStyle: {
            "color": "green"
          }
        })]) : _c('el-tooltip', {
          attrs: {
            "content": "demo",
            "placement": "top"
          }
        }, [_c('i', {
          staticClass: "el-icon-error",
          staticStyle: {
            "color": "red"
          }
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "30px"
    },
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [20, 50, 100],
      "total": _vm.totalPages,
      "layout": "sizes, prev, pager, next",
      "page-size": _vm.offset
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    }
  }), _vm._v(" "), (_vm.formLoadingDone) ? _c('form', {
    ref: "create-edit-block",
    staticClass: "form",
    attrs: {
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.layoutTagAssociation($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('h5', [_vm._v("Choose Adspot on Layout")]), _vm._v(" "), _c('el-select', {
    key: _vm.randomNumber,
    attrs: {
      "placeholder": "Search and select a layout adspot",
      "filterable": "",
      "multiple": "",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.checkDisabled()
      }
    },
    model: {
      value: (_vm.formData.layout),
      callback: function($$v) {
        _vm.$set(_vm.formData, "layout", $$v)
      },
      expression: "formData.layout"
    }
  }, _vm._l((_vm.allAdSpotsWithLayouts), function(adspot) {
    return _c('el-option', {
      key: adspot.id +
        '-' +
        adspot.ad_spot.unique_id +
        ' - ' +
        adspot.layout.layout_name,
      attrs: {
        "label": _vm.getLabel(adspot),
        "value": adspot.id,
        "disabled": adspot.alreadyAssociated || adspot.alreadyAssigned
      }
    }, [_vm._v("\n                                    " + _vm._s(_vm.getLabel(adspot)) + "\n\n                                    "), (adspot.alreadyAssociated) ? _c('span', {
      staticStyle: {
        "color": "red",
        "font-style": "italic",
        "margin-left": "5px"
      }
    }, [_vm._v("USED")]) : _vm._e()])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('h5', [_vm._v("HB?")]), _vm._v(" "), _c('div', {
    staticClass: "m-t-5"
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#13ce66"
    },
    model: {
      value: (_vm.formData.hbEnabled),
      callback: function($$v) {
        _vm.$set(_vm.formData, "hbEnabled", $$v)
      },
      expression: "formData.hbEnabled"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.formData.hbEnabled),
      expression: "!formData.hbEnabled"
    }],
    staticClass: "col-md-6"
  }, [_c('h5', [_vm._v("Select DFP Adunit")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Search and select a dfp adunit",
      "filterable": "",
      "remote": "",
      "remote-method": _vm.getDfpAdunits,
      "loading": _vm.loading
    },
    on: {
      "change": _vm.adUnitChange
    },
    model: {
      value: (_vm.formData.dfpAdUnit),
      callback: function($$v) {
        _vm.$set(_vm.formData, "dfpAdUnit", $$v)
      },
      expression: "formData.dfpAdUnit"
    }
  }, _vm._l((_vm.dfpAdUnits), function(adunit) {
    return _c('el-option', {
      key: adunit.ad_unit_id,
      attrs: {
        "label": _vm.domain_details.dfp_network.network_code + '/' + adunit.ad_unit_name,
        "value": adunit.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formData.hbEnabled),
      expression: "formData.hbEnabled"
    }],
    staticClass: "col-md-4"
  }, [_c('h5', [_vm._v("Select Hb Adunit")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Search and select a HB adunit",
      "filterable": "",
      "remote": "",
      "remote-method": _vm.getHbAdunits,
      "loading": _vm.loading,
      "multiple-limit": this.isMultiAdUnit ? 0 : 1,
      "multiple": ""
    },
    on: {
      "change": _vm.adUnitChange
    },
    model: {
      value: (_vm.formData.hbAdUnits),
      callback: function($$v) {
        _vm.$set(_vm.formData, "hbAdUnits", $$v)
      },
      expression: "formData.hbAdUnits"
    }
  }, _vm._l((_vm.hbAdUnits), function(adunit) {
    return _c('el-option', {
      key: adunit.id,
      attrs: {
        "label": _vm.getAdunitPath(adunit),
        "value": adunit.id
      }
    })
  }), 1), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searchingAdUnit),
      expression: "searchingAdUnit"
    }],
    staticClass: "el-icon-loading",
    staticStyle: {
      "position": "absolute",
      "top": "50px",
      "right": "20px"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('h5', [_vm._v("Live?")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-color": "#13ce66"
    },
    model: {
      value: (_vm.formData.is_live),
      callback: function($$v) {
        _vm.$set(_vm.formData, "is_live", $$v)
      },
      expression: "formData.is_live"
    }
  })], 1), _vm._v(" "), (_vm.formData.hbAdUnits || _vm.formData.dfpAdUnit) ? _c('div', {
    staticClass: "col-md-10"
  }, [_c('h5', [_vm._v("Choose Dimensions")]), _vm._v(" "), _c('el-checkbox-group', {
    model: {
      value: (_vm.formData.checkedDimensions),
      callback: function($$v) {
        _vm.$set(_vm.formData, "checkedDimensions", $$v)
      },
      expression: "formData.checkedDimensions"
    }
  }, _vm._l((_vm.formData.availableDimensions), function(dimension) {
    return _c('el-checkbox', {
      key: dimension.id,
      staticClass: "col-md-2",
      attrs: {
        "label": dimension.id,
        "disabled": _vm.isDisabled(dimension.id),
        "title": _vm.isDisabled(dimension.id) ? 'At least one dimension to be associated' : ''
      }
    }, [_vm._v("\n                                    " + _vm._s(dimension.width) + " X\n                                    " + _vm._s(dimension.height) + "\n                                ")])
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isMultiAdUnit && !_vm.loading) ? _c('div', {
    staticClass: "col-md-12 splitObject"
  }, [_c('h5', [_vm._v("Configure the split Object.")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%",
      "border-spacing": "0"
    },
    attrs: {
      "height": "350",
      "data": _vm.formData.splitObject,
      "id": "split-table"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Size",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [(_vm.dimensions.length) ? _c('el-select', {
          staticStyle: {
            "display": "inline-block",
            "max-width": "300px",
            "flex": "initial"
          },
          attrs: {
            "placeholder": "Select dimensions",
            "filterable": "",
            "loading": _vm.loading
          },
          model: {
            value: (props.row.size),
            callback: function($$v) {
              _vm.$set(props.row, "size", $$v)
            },
            expression: "props.row.size"
          }
        }, _vm._l((_vm.dimensions), function(dimension, index) {
          return _c('el-option', {
            key: 'splitSize' + index,
            staticStyle: {
              "width": "100%"
            },
            attrs: {
              "label": ((dimension.width) + "x" + (dimension.height)),
              "value": ((dimension.width) + "x" + (dimension.height))
            }
          })
        }), 1) : _vm._e()]
      }
    }], null, false, 3017947378)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Count",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-input', {
          staticStyle: {
            "flex": "initial",
            "width": "100px"
          },
          style: (isNaN(parseInt(props.row.count)) && 'border: 1.5px solid red; border-radius: 6px;'),
          attrs: {
            "name": "splitCount",
            "type": "number",
            "placeholder": "count",
            "disabled": props.row.count === 1 ? true : false
          },
          model: {
            value: (props.row.count),
            callback: function($$v) {
              _vm.$set(props.row, "count", $$v)
            },
            expression: "props.row.count"
          }
        })]
      }
    }], null, false, 1486279318)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Percent",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-input', {
          ref: "percentInput",
          staticStyle: {
            "flex": "initial",
            "width": "100px"
          },
          style: (isNaN(parseInt(props.row.percent)) && 'border: 1.5px solid red; border-radius: 6px;'),
          attrs: {
            "name": "splitPercent",
            "type": "number",
            "placeholder": "percent"
          },
          model: {
            value: (props.row.percent),
            callback: function($$v) {
              _vm.$set(props.row, "percent", $$v)
            },
            expression: "props.row.percent"
          }
        })]
      }
    }], null, false, 2211078975)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Adunit"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v("\n                                        " + _vm._s(props.row.adUnitId) + "\n                                    ")]
      }
    }], null, false, 3544192307)
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "el-button btn-rounded el-button--success",
    attrs: {
      "disabled": !_vm.formData.layout ||
        _vm.formData.layout.length === 0 ||
        (_vm.formData.hbEnabled && !_vm.formData.hbAdUnits) ||
        (!_vm.formData.hbEnabled && !_vm.formData.dfpAdUnit) ||
        _vm.formData.checkedDimensions && _vm.formData.checkedDimensions.length == 0 ||
        (_vm.isValidSplitObject(_vm.formData.splitObject) !== '')
    }
  }, [_c('i', {
    staticClass: "ti-save"
  }), _vm._v("\n                                " + _vm._s(!_vm.formData.id ? 'Save' : 'Update') + "\n                            ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "white-space": "nowrap"
    }
  }, [_vm._v(_vm._s(_vm.isValidSplitObject(_vm.formData.splitObject)))])])])]) : _vm._e()], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4990504a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/first-impression/FiTagAssociation.vue
// module id = 689
// module chunks = 2